export default __webpack_public_path__ + "static/media/k.c5b2e1d2.svg";